export default "__VITE_ASSET__BsqH9ArA__"